import * as axios from '../../utilities/axios'

export const regionsForState = stateShortName => {
  return axios.basic
    .get(
      `${
        process.env.PARSE_DIR
      }/classes/TrafficRegion?where={"state":"${stateShortName}"}&keys=image,name,objectId,state,configuration,order`
    )
    .then(res => res.data.results)
    .catch(axios.parseError)
}

export const getByObjectId = regionObjectId => {
  return axios.basic
    .get(
      `/api/v1/traffic/regions/${regionObjectId}`
    )
    .then(res => res.data)
    .catch(axios.parseError)
}

// export const getByObjectId = regionObjectId => {
//   return axios.basic
//     .get(
//       `${
//         process.env.PARSE_DIR
//       }/classes/TrafficRegion/${regionObjectId}?include=trafficCounties,trafficCounties.trafficCourts,trafficCounties.trafficCourts.courtName,trafficCourts`
//     )
//     .then(res => res.data)
//     .catch(axios.parseError)
// }


